let relatedProductsSwiperInitialized = false;
let relatedProductsSwiperInstances = {};

// ブレイクポイントの定義
const BREAKPOINT_MOBILE = 376; // 376px以下
const BREAKPOINT_TABLET_SMALL = 764; // 377px〜764px
const BREAKPOINT_TABLET_LARGE = 989; // 765px〜989px
const BREAKPOINT_PC_MEDIUM = 1199; // 990px〜1199px
// 1200px以上はPC大

// ページが完全に読み込まれたことを確認するイベント
window.addEventListener("load", function () {
  console.log(
    "関連商品: Window fully loaded - attempting Swiper initialization"
  );
  initAllRelatedSwipers();
});

document.addEventListener("DOMContentLoaded", function () {
  console.log("関連商品: DOM Content Loaded - setting up observation");

  const productRecommendations = document.querySelector(
    "product-recommendations"
  );

  if (productRecommendations) {
    console.log(
      "関連商品: Found product-recommendations component, waiting for recommendations:loaded event"
    );

    productRecommendations.addEventListener(
      "recommendations:loaded",
      function () {
        console.log("関連商品: recommendations:loaded event fired");

        setTimeout(function () {
          initAllRelatedSwipers();
        }, 500);
      }
    );
  }

  setTimeout(function () {
    if (!relatedProductsSwiperInitialized) {
      console.log("関連商品: Attempting initial Swiper initialization");
      initAllRelatedSwipers();
    }
  }, 300);

  setTimeout(function () {
    if (!relatedProductsSwiperInitialized) {
      console.log("関連商品: Backup initialization attempt");
      initAllRelatedSwipers();
    }
  }, 2000);
});

function initAllRelatedSwipers() {
  const swiperSections = document.querySelectorAll(
    '[id^="related-container-"]'
  );

  console.log(
    `関連商品: Found ${swiperSections.length} Swiper sections to initialize`
  );

  if (swiperSections.length === 0) {
    console.log("関連商品: No Swiper sections found yet, will retry later");
    return;
  }

  swiperSections.forEach((section) => {
    const sectionId = section.id.replace("related-container-", "");
    initRelatedSwiper(sectionId);
  });

  relatedProductsSwiperInitialized = true;

  if (typeof iWish !== 'undefined'){
      iWish.checkIwishColl();
  }
}

function initRelatedSwiper(sectionId) {
  console.log(`関連商品: Initializing Swiper for section ${sectionId}`);

  if (relatedProductsSwiperInstances[sectionId]) {
    console.log(
      `関連商品: Destroying existing Swiper instance for section ${sectionId}`
    );
    relatedProductsSwiperInstances[sectionId].destroy(true, true);
    delete relatedProductsSwiperInstances[sectionId];
  }

  const swiperContainer = document.querySelector(
    `.swiper-related-products-${sectionId}`
  );
  if (!swiperContainer) {
    console.error(
      `関連商品: Swiper container not found for section ${sectionId}`
    );
    return;
  }

  const nextButton = document.querySelector(`#swiper-button-next-${sectionId}`);
  const prevButton = document.querySelector(`#swiper-button-prev-${sectionId}`);

  if (!nextButton || !prevButton) {
    console.warn(
      `関連商品: Navigation buttons not found for section ${sectionId}`
    );
  } else {
    console.log(`関連商品: Navigation buttons found for section ${sectionId}`);

    // カスタムのナビゲーションボタンをクリアして再設定
    nextButton.onclick = null;
    prevButton.onclick = null;
  }

  try {
    const windowWidth = window.innerWidth;
    const isTabletSmall =
      windowWidth <= BREAKPOINT_TABLET_SMALL && windowWidth >= 377;
    const isMobile = windowWidth <= BREAKPOINT_MOBILE;

    console.log(
      `関連商品: Window width: ${windowWidth}px, isTabletSmall: ${isTabletSmall}, isMobile: ${isMobile}`
    );

    let currentSlidesPerView = 1;
    let currentSpaceBetween = 10;

    // if (isMobile) {
    //   currentSlidesPerView = 1; // 2→2.5に変更して空白を解消
    //   currentSpaceBetween = 8;
    // } else if (isTabletSmall) {
    //   currentSlidesPerView = 2; // 377px〜764pxでは2スライド表示
    //   currentSpaceBetween = 10;
    // } else if (windowWidth <= BREAKPOINT_TABLET_LARGE) {
    //   currentSlidesPerView = 3; // 765px〜989pxでは3スライド表示
    //   currentSpaceBetween = 10;
    // } else if (windowWidth <= BREAKPOINT_PC_MEDIUM) {
    //   currentSlidesPerView = 4; // 990px〜1199pxでは4スライド表示
    //   currentSpaceBetween = 10;
    // }

    // ブレイクポイント設定の修正
    const swiperBreakpoints = {
      0: {
        slidesPerView: 2,
        spaceBetween: 10,
        slidesPerGroup: 1,
        centeredSlides: false,
      },
      320: {
        slidesPerView: 1.5,
        spaceBetween: 10,
        slidesPerGroup: 1,
        centeredSlides: false,
      },

      375: {
        slidesPerView: 2.4,
        spaceBetween: 10,
        slidesPerGroup: 1,
        centeredSlides: false,
      },
      390: {
        slidesPerView: 2.3,
        spaceBetween: 10,
        slidesPerGroup: 1,
        centeredSlides: false,
      },

      450: {
        slidesPerView: 2.5,
        spaceBetween: 15,
        slidesPerGroup: 1,
        centeredSlides: false,
      },

      550: {
        slidesPerView: 3.5,
        spaceBetween: 15,
        slidesPerGroup: 1,
        centeredSlides: false,
      },

      650: {
        slidesPerView: 3.5,
        spaceBetween: 20,
        slidesPerGroup: 1,
        centeredSlides: false,
      },

      750: {
        slidesPerView: 3,
        spaceBetween: 20,
        slidesPerGroup: 1,
        centeredSlides: false,
      },

      765: {
        slidesPerView: 3,
        spaceBetween: 25,
        slidesPerGroup: 1,
        centeredSlides: false,
      },

      990: {
        slidesPerView: 4,
        spaceBetween: 20,
        slidesPerGroup: 1,
        centeredSlides: false,
      },
      1200: {
        slidesPerView: 5,
        spaceBetween: 20,
        slidesPerGroup: 1,
        centeredSlides: false,
      },
    };

    // スライダーオプションの修正
    const swiperOptions = {
      slidesPerView: currentSlidesPerView,
      spaceBetween: currentSpaceBetween,
      loop: true, // 常にループを有効にする
      slidesPerGroup: 1,
      centeredSlides: false,
      // slidesOffsetAfter: isMobile ? 15 : 0, // スマホサイズの場合のみ右に余白を追加
      // slidesOffsetBefore: isMobile ? 15 : 0, // スマホサイズの場合のみ左に余白を追加
      loopAdditionalSlides: 1, // 追加のスライドを設定
      loopFillGroupWithBlank: false, // グループを空白で埋めない
      observer: true,
      observeParents: true,
      resizeObserver: true,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      preventClicksPropagation: false,
      preventClicks: false,
      simulateTouch: true,
      navigation: {
        nextEl: `#swiper-button-next-${sectionId}`,
        prevEl: `#swiper-button-prev-${sectionId}`,
      },
      grabCursor: true,
      watchOverflow: true,
      slideToClickedSlide: false,
      speed: 300,
      followFinger: true,
      freeMode: false,
      freeModeSticky: false,
      threshold: 5,
      touchRatio: 1,
      shortSwipes: true,
      longSwipes: true,
      longSwipesRatio: 0.5,
      longSwipesMs: 300,
      a11y: {
        enabled: true,
        prevSlideMessage: "前のスライド",
        nextSlideMessage: "次のスライド",
      },
      breakpoints: swiperBreakpoints,
      on: {
        init: function () {
          console.log(
            `関連商品: Swiper for section ${sectionId} initialized successfully with ${currentSlidesPerView} slides per view`
          );
          console.log(
            `関連商品: Swiper group settings - slidesPerGroup: 1, loop: true, slidesOffsetBefore: ${
              isMobile ? 15 : 0
            }`
          );
          updateNavigationVisibility(sectionId);
        },
        slideChange: function () {
          console.log(`関連商品: Slide changed to ${this.activeIndex} (real: ${this.realIndex})`);
        },
        update: function () {
          console.log(`関連商品: Swiper for section ${sectionId} updated`);
        },
        breakpoint: function (swiper, breakpointParams) {
          console.log(
            `関連商品: Breakpoint triggered: ${JSON.stringify(
              breakpointParams
            )}`
          );
        },
      },
    };

    // Swiperインスタンスの作成
    relatedProductsSwiperInstances[sectionId] = new Swiper(
      `.swiper-related-products-${sectionId}`,
      swiperOptions
    );

    // カスタムナビゲーションロジックの設定（インスタンス作成後に実行）
    if (nextButton && prevButton) {
      nextButton.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();
        console.log("関連商品: Next button clicked");

        const swiper = relatedProductsSwiperInstances[sectionId];
        if (swiper) {
          // 現在のインデックスと表示枚数を取得
          const currentIndex = swiper.activeIndex;
          const slidesPerView = swiper.params.slidesPerView;

          // 1スライドずつ移動させる（スマホサイズでも確実に1枚だけ移動）
          swiper.slideNext();
          console.log(
            `関連商品: Moving from slide ${currentIndex} to ${swiper.activeIndex}`
          );
        }
      };

      prevButton.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();
        console.log("関連商品: Previous button clicked");

        const swiper = relatedProductsSwiperInstances[sectionId];
        if (swiper) {
          // 現在のインデックスと表示枚数を取得
          const currentIndex = swiper.activeIndex;

          // 1スライドずつ移動させる（スマホサイズでも確実に1枚だけ移動）
          swiper.slidePrev();
          console.log(
            `関連商品: Moving from slide ${currentIndex} to ${swiper.activeIndex}`
          );
        }
      };
    }

    console.log(`関連商品: Swiper instance created for section ${sectionId}`);

    function updateNavigationVisibility(sectionId) {
      const totalSlides = document.querySelectorAll(
        `.swiper-related-products-${sectionId} .swiper-slide:not(.swiper-slide-duplicate)`
      ).length;

      console.log(
        `関連商品: Total slides for section ${sectionId}: ${totalSlides}`
      );

      let slidesPerView;
      const windowWidth = window.innerWidth;

      if (windowWidth >= 1200) {
        slidesPerView = 5;
      } else if (windowWidth >= 990) {
        slidesPerView = 4;
      } else if (windowWidth >= 765) {
        slidesPerView = 3;
      } else {
        slidesPerView = 2;
      }

      if (totalSlides <= slidesPerView) {
        if (nextButton) nextButton.style.display = "none";
        if (prevButton) prevButton.style.display = "none";
        console.log(
          `関連商品: Navigation buttons hidden for section ${sectionId} (too few slides)`
        );
      } else {
        if (nextButton) nextButton.style.display = "flex";
        if (prevButton) prevButton.style.display = "flex";
        console.log(
          `関連商品: Navigation buttons shown for section ${sectionId}`
        );
      }
    }

    updateNavigationVisibility(sectionId);

    let resizeRelatedTimer;
    window.addEventListener("resize", function () {
      clearTimeout(resizeRelatedTimer);
      resizeRelatedTimer = setTimeout(function () {
        console.log("関連商品: Window resized - updating settings");

        updateNavigationVisibility(sectionId);

        const swiper = relatedProductsSwiperInstances[sectionId];
        if (swiper) {
          swiper.update();
        }
      }, 250);
    });
  } catch (error) {
    console.error(
      `関連商品: Error initializing Swiper for section ${sectionId}:`,
      error
    );
  }
}

const relatedObserver = new MutationObserver(function (mutations) {
  let shouldReinitialize = false;

  for (let mutation of mutations) {
    if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
      for (let node of mutation.addedNodes) {
        if (
          node.nodeType === 1 &&
          ((node.classList && node.classList.contains("swiper-container")) ||
            (node.querySelector && node.querySelector(".swiper-container")))
        ) {
          shouldReinitialize = true;
          break;
        }
      }
    }

    if (shouldReinitialize) break;
  }

  if (shouldReinitialize && !relatedProductsSwiperInitialized) {
    console.log(
      "関連商品: DOM changed significantly - attempting to initialize Swipers"
    );
    setTimeout(initAllRelatedSwipers, 300);
  }
});

relatedObserver.observe(document.body, {
  childList: true,
  subtree: true,
});